import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import GettingStartedPage from './pages/GettingStartedPage'
import GuideListPage from './pages/GuideListPage'
import GuideDetailPage from './pages/GuideDetailPage'
import LevelGuidePage from './pages/LevelGuidePage'
import FAQPage from './pages/FAQPage'
import TroubleshootingPage from './pages/TroubleshootingPage'
import SearchResultsPage from './pages/SearchResultsPage'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/getting-started" element={<GettingStartedPage />} />
          <Route path="/guides" element={<GuideListPage />} />
          <Route path="/guides/:slug" element={<GuideDetailPage />} />
          <Route path="/level/:level" element={<LevelGuidePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/troubleshooting" element={<TroubleshootingPage />} />
          <Route path="/search" element={<SearchResultsPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App